var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { HTMLRenderer } from '../renderer/HTMLRenderer';
var ReadonlyEditor = function (_a) {
    var _b, _c;
    var _d = _a.useStorageUrl, useStorageUrl = _d === void 0 ? true : _d, _e = _a.value, value = _e === void 0 ? null : _e, _f = _a.onChange, onChange = _f === void 0 ? null : _f, _g = _a.onChangeLang, onChangeLang = _g === void 0 ? null : _g, passedLang = _a.lang, cellPlugins = _a.cellPlugins, children = _a.children, _h = _a.cellSpacing, cellSpacing = _h === void 0 ? null : _h, options = __rest(_a, ["useStorageUrl", "value", "onChange", "onChangeLang", "lang", "cellPlugins", "children", "cellSpacing"]);
    var lang = (_c = passedLang !== null && passedLang !== void 0 ? passedLang : (_b = options.languages) === null || _b === void 0 ? void 0 : _b[0].lang) !== null && _c !== void 0 ? _c : 'default';
    var renderOptions = {
        cellPlugins: cellPlugins,
        cellSpacing: cellSpacing,
    };
    var callbacks = {
        onChange: onChange,
        onChangeLang: onChangeLang,
    };
    return (React.createElement(HTMLRenderer, { useStorageUrl: useStorageUrl, value: value, cellPlugins: cellPlugins, lang: lang, cellSpacing: cellSpacing }));
};
export default ReadonlyEditor;
//# sourceMappingURL=ReadonlyEditor.js.map